import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage"; // [추가됨] 이미지 저장소 기능

// 1. Firebase 설정 정보
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// 2. 앱 초기화
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// [NEW] Use new Firestore persistence API (replaces deprecated enableIndexedDbPersistence)
// 테스트 환경에서는 persistence 비활성화 (Emulator와 충돌 방지)
const isTestEnv = process.env.REACT_APP_USE_EMULATOR === 'true' || window.Cypress;

const db = isTestEnv
  ? initializeFirestore(app, {})
  : initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager()
    })
  });

const storage = getStorage(app); // [추가됨] 저장소 초기화

// [NEW] Firebase Emulator 연결 (테스트 환경에서만)
if (isTestEnv) {
  console.log('🧪 Firebase Emulator에 연결합니다...');
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);
}

// 3. App ID 설정 (데이터 경로용)
const rawAppId =
  typeof __app_id !== "undefined" ? __app_id : "youth-ministry-app";
const appId = rawAppId.replace(/\//g, "_");

// 4. 내보내기 (storage 추가됨)
export { app, auth, db, storage, appId };
